import { render } from "./BookingRegistration.vue?vue&type=template&id=a8cc6dd4"
import script from "./BookingRegistration.vue?vue&type=script&lang=js"
export * from "./BookingRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__